import * as FluxUtils from 'flux/utils';
import { t } from 'i18next';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { CameraHelper } from '../utils/CameraHelper';

import core = egr.wcf.core;

export interface SelectBoxOption {
    name: string;
    key: string | number;
    callback?: () => void;
    className?: string;
    icon?: string;
    disabled?: boolean;
    extraButtons?: Array<JSX.Element>;
    hidden?: boolean;
}

export interface SelectBoxStoreState {
    options: Array<SelectBoxOption>;
    title: string;
    sender: string | number;
    value: string | number | boolean | null;
    activeDesktopSelectBox?: string | number | null;
    asOverlay: boolean;
}

class SelectBoxStoreClass extends FluxUtils.ReduceStore<SelectBoxStoreState, unknown> {
    public getInitialState(): SelectBoxStoreState {
        return {
            options: [],
            title: '',
            sender: 0,
            value: null,
            activeDesktopSelectBox: null,
            asOverlay: false
        };
    }

    public getCameraOptions(): Array<SelectBoxOption> {
        return [
            {
                name: t('Perspective'),
                key: core.view.CameraMode.Perspective,
                className: 'camera-pers',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Perspective); }
            },
            {
                name: t('Orthographic'),
                key: core.view.CameraMode.Orthographic,
                className: 'camera-ortho',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Orthographic); }
            },
            {
                name: t('Front'),
                key: core.view.CameraMode.Front,
                className: 'camera-front',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Front); }
            },
            {
                name: t('Top'),
                key: core.view.CameraMode.Top,
                className: 'camera-top',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Top); }
            },
            {
                name: t('Left'),
                key: core.view.CameraMode.Left,
                className: 'camera-left',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Left); }
            },
            {
                name: t('Right'),
                key: core.view.CameraMode.Right,
                className: 'camera-right',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Right); }
            },
            {
                name: t('Rear'),
                key: core.view.CameraMode.Back,
                className: 'camera-back',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Back); }
            },
            {
                name: t('Bottom'),
                key: core.view.CameraMode.Bottom,
                className: 'camera-bottom',
                callback: () => {CameraHelper.setCameraMode(core.view.CameraMode.Bottom); }
            }
        ];
    }

    public reduce(state: SelectBoxStoreState, action: DispatcherBaseAction): SelectBoxStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed
        switch (action.actionType) {
            case ActionConstants.SET_ACTIVE_SELECTBOX:
                return jQuery.extend(
                    {},
                    state,
                    {activeDesktopSelectBox: action.value}
                );
            case ActionConstants.CHANGE_HAMBURGER:
            case ActionConstants.CHANGE_SIDEBAR:
                return jQuery.extend(
                    {},
                    state,
                    {options: [], title: '', sender: 0, value: 0},
                    {activeDesktopSelectBox: null}
                );
            case ActionConstants.SHOW_SELECTBOX:
                return jQuery.extend(
                    {},
                    state,
                    action.value
                );
            default:
                return state;
        }
    }
}

export let SelectBoxStore: SelectBoxStoreClass = new SelectBoxStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/SelectBoxStore.ts